import { jsx } from "react/jsx-runtime";
import { useClassName } from "@contember/react-utils";
import { memo, useContext } from "react";
import { UseTableElementContext } from "./Table.js";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
import { toViewClass } from "../../utils/toViewClass.js";
const TableCell = memo(({ shrunk = false, numeric = false, ...props }) => {
  const useTableElement = useContext(UseTableElementContext);
  const className = useClassName("table-cell", [
    toEnumViewClass(props.alignment),
    toEnumViewClass(props.justification),
    toViewClass("numeric", numeric),
    toViewClass("shrunk", shrunk)
  ]);
  if (useTableElement) {
    return /* @__PURE__ */ jsx("td", { className, colSpan: props.colSpan, children: props.children });
  }
  return /* @__PURE__ */ jsx("div", { className, children: props.children });
});
TableCell.displayName = "TableCell";
export {
  TableCell
};
//# sourceMappingURL=TableCell.js.map
